import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck, Lock, Eye, Server, RefreshCw } from "lucide-react";

export default function PrivacyPolicyPage() {
  return (
    <div className="space-y-6 animate-fade-in max-w-4xl mx-auto" data-testid="privacy-policy-page">
      {/* Top Header with Back Navigation */}
      <div className="flex items-center justify-between">
        <Link
          to="/calendar"
          data-testid="privacy-back-btn"
          className="inline-flex items-center gap-2 text-xs sm:text-sm font-bold text-pink-900 hover:text-pink-950 bg-white px-4 py-2 rounded-xl border border-pink-200 shadow-sm transition-all"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>Back to Calendar</span>
        </Link>

        <span className="text-xs font-semibold text-gray-500">
          Legal & Privacy
        </span>
      </div>

      {/* Main Container Card */}
      <div className="bg-white rounded-3xl border border-pink-100 shadow-xl overflow-hidden">
        {/* Banner */}
        <div className="bg-gradient-to-r from-pink-900 via-pink-800 to-rose-800 p-6 sm:p-8 text-white">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/20 text-xs font-semibold mb-2">
            <ShieldCheck className="w-3.5 h-3.5 text-pink-200" />
            <span>Privacy Protection</span>
          </div>
          <h1 className="text-2xl sm:text-3xl font-black tracking-tight">
            Privacy Policy
          </h1>
          <p className="text-pink-100 text-xs sm:text-sm mt-1 max-w-xl">
            How BookMyEvents secures your convention hall bookings, customer phone numbers, advance payments, and financial ledgers.
          </p>
        </div>

        {/* Content Body */}
        <div className="p-6 sm:p-8 space-y-6 bg-white text-xs sm:text-sm text-gray-700 leading-relaxed">
          
          <section className="space-y-2">
            <h2 className="text-sm sm:text-base font-bold text-pink-950 flex items-center gap-2">
              <Lock className="w-4 h-4 text-pink-700" />
              <span>1. Information We Collect</span>
            </h2>
            <p>
              When convention hall managers and owners register on BookMyEvents, we collect business name, contact person details, phone numbers, email addresses, and venue location. For every booking record created, we securely store event dates, slot choices, customer names, contact numbers, and payment breakdown figures.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-sm sm:text-base font-bold text-pink-950 flex items-center gap-2">
              <Server className="w-4 h-4 text-pink-700" />
              <span>2. Cloud Synchronization & Security</span>
            </h2>
            <p>
              Your data is stored in enterprise-grade encrypted databases managed by Bharath Developers. Customer financial records, GST calculations, and invoices are accessible exclusively by your authenticated account.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-sm sm:text-base font-bold text-pink-950 flex items-center gap-2">
              <Eye className="w-4 h-4 text-pink-700" />
              <span>3. Hall Finder Directory Visibility</span>
            </h2>
            <p>
              If you enable listing on Hall Finder, only public venue details (hall name, city, guest capacity, amenities, and default rates) are displayed to potential organizers. Private customer booking records and balance payments are never shared publicly.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-sm sm:text-base font-bold text-pink-950 flex items-center gap-2">
              <RefreshCw className="w-4 h-4 text-pink-700" />
              <span>4. Updates to This Policy</span>
            </h2>
            <p>
              We may update this Privacy Policy from time to time. Continued use of BookMyEvents after any modification constitutes acceptance of the revised policy.
            </p>
          </section>

          <div className="pt-4 border-t border-gray-100 text-[11px] text-gray-400">
            Last Updated: March 2025 • BookMyEvents by Bharath Developers
          </div>
        </div>
      </div>
    </div>
  );
}
